import { useEffect } from "react";
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton } from '@albo-ui/core';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { useSingleView } from "./hooks/useSingleView";
import { SectionItem } from "../../elements";
import { Box, Tabs, Tab, Divider, Avatar } from "@mui/material";
import { cardsStatus } from "../../../util/DataObject";

import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import StyleIcon from '@mui/icons-material/Style';

export const SingleCustomerView = ({ changeAlert, changeLoader, sectionData }: any) => {
    const { theme } = useThemeProvider();
    const { data, columns, sectionOne, sectionTwo, sectionThree, loading: loadingData, tabs, tabActive, status, saveData, changeTab, findActiveTab } = useSingleView(changeAlert);

    useEffect(() => {
        saveData(sectionData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingData]);

    const sectionItem = (sectionName, title=null) => {
		return (
            <FlexGrid container item direction="column" spacing={1}>
                {data[title || sectionName] && columns[sectionName]?.map((item, index) => {
                    return <SectionItem key={index} data={data[title || sectionName]} item={item} index={index} widthA={item.widthA || null} widthB={item.widthB || null} />
                })}
            </FlexGrid>
        )
    }
    
    return (
        <Card padding={4} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee }}> 
            <FlexGrid container fullWidth direction="column">
                <FlexGrid item>
                    <Typography variant='h2' style={{display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem'}}>
                        <PermContactCalendarIcon sx={{ marginRight: 1 }}/> Información General
                    </Typography>
                </FlexGrid>
            </FlexGrid>

            {loadingData && Object.keys(data).length > 0 ?
                <Skeleton width='100%' height='100px' />
                :
                <>
                <FlexGrid container spacing={2} style={{ margin: '25px 0' }} justify="space-between" >
                    <Box alignItems={"center"} display={'flex'}>
                        <Avatar sx={{width: "5rem", height: "5rem"}}>
                            {data['01_gral_info'] && data['01_gral_info']['gender'] === "Femenino" ? <LocalFloristIcon fontSize="large"/> : <AgricultureIcon fontSize="large"/>}
                        </Avatar>
                        <Box display={"grid"}>
                            <Typography variant="h2" style={{marginLeft: 20}}>
                            {data['01_gral_info'] && data['01_gral_info']['first_name']}
                            </Typography>
                            <Typography variant="h2" style={{marginLeft: 20}}>
                            {data['01_gral_info'] && data['01_gral_info']['last_name']}
                            </Typography>
                        </Box>
                    </Box>
                    {sectionOne.map((item) => {
                        return <FlexGrid key={item.sectionName} item style={{width: "50%"}}>
                            {sectionItem(item.sectionName)}
                        </FlexGrid>
                    })}
                </FlexGrid>
                <Divider sx={{mb: 3}}/>

                {/* ------------------------------------------------ */}
                <FlexGrid container fullWidth direction="column">
                    <FlexGrid item>
                        <Typography variant='h2' style={{display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem'}}>
                            <StyleIcon sx={{ marginRight: 1 }}/> Información de Productos
                        </Typography>
                    </FlexGrid>
                </FlexGrid>

                <FlexGrid container spacing={2} style={{ margin: '15px 0' }}>
                    <FlexGrid item fullWidth >
                    {sectionTwo.map((item) => {
                        return <FlexGrid key={item.sectionName} item style={{width: "-webkit-fill-available"}}>
                            {sectionItem(item.sectionName, item.title)}
                        </FlexGrid>
                    })}
                    </FlexGrid>
                    <FlexGrid item fullWidth >
                    {sectionThree.map((item) => {
                        return <FlexGrid key={item.sectionName} item style={{width: "-webkit-fill-available"}}>
                            {sectionItem(item.sectionName, item.title)}
                        </FlexGrid>
                    })}
                    </FlexGrid>
                </FlexGrid>

                {data['02_product_info'] && 
                    <FlexGrid container spacing={2}>
                        {columns.cards.map((card) => {
                            var result = cardsStatus.filter((s) => s.key === data['02_product_info'][card.key])[0]
                            return <FlexGrid key={card.key} item style={{width: "-webkit-fill-available"}}>
                                {status(card.name, result ? result.label : null, card.key )}
                            </FlexGrid>
                        })}
                    </FlexGrid>
                }

                <Divider sx={{my: 6}}/>

                {/* ------------------------------------------------ */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
                    <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary' variant="fullWidth" centered>
                        {tabs.map((item, index) => {
                            return <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.name)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18}} />
                        })}
                    </Tabs>
                </Box>

                {(tabActive === "03_trans_info" || tabActive === "04_balance") && data[tabActive] && 
                    <FlexGrid container spacing={2} justify="space-between" >
                        <FlexGrid item style={{width: "-webkit-fill-available"}}>
                            {sectionItem(tabActive)}
                        </FlexGrid>
                    </FlexGrid>
                }
                </>
            }
        </Card>
    )
}

